import React, { useState, useRef } from "react";
import { useEffect } from "react";
import './login.css'
import Cookies from 'js-cookie';
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router";
import { notify } from '../../services/notification';
import { generateEmailOtp, verifyEmailOtp } from "../../actions/loginAction";
import { setUserAuthCookies } from "../../utils/authCookies";
import { SET_FIRST_LOGIN } from "../../actions/types";
import { FaEye, FaEyeSlash } from 'react-icons/fa'
import Loader from "../../component/loaderComponent/loaderComponent/Loader";
import { EMAIL_REGEX } from "../../constants/regex/regex";

function Login() {
  const [state, setDataState] = useState({
    email: "",
    password: "",
  })
  const [Error, setError] = useState({
    emailError: "",
    passwordError: ""
  });
  const environment = process.env.REACT_APP_ENV;

  const [isPasswordVisible, setPasswordVisible] = useState(false);
  const [isLoading, setIsloading] = useState(false);
  const [isButtonDisabled, setButtonDisabled] = useState(false);
  const [isOtpStep, setIsOtpStep] = useState(false);
  const [otp, setOtp] = useState("");

  const [otpTimer, setOtpTimer] = useState(0);
  const [canResendOtp, setCanResendOtp] = useState(false);
  const intervalRef = useRef(null);
  const otpRefs = useRef([]);

  useEffect(() => {

    if (isOtpStep && otpTimer > 0 && !intervalRef.current) {

      intervalRef.current = setInterval(() => {
        setOtpTimer(prev => {
          if (prev <= 1) {
            clearInterval(intervalRef.current);
            intervalRef.current = null;
            setCanResendOtp(true);
            return 0;
          }
          return prev - 1;
        });
      }, 1000);

    }

    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
    };

  }, [isOtpStep]);

  const handlePasswordVisibility = () => {
    setPasswordVisible(!isPasswordVisible);
  };

  const dispatch = useDispatch();
  const navigate = useNavigate()

  const handleChange = (evt) => {
    const value = evt.target.value;
    setDataState({
      ...state,
      [evt.target.name]: value.replace(/^ +/gm, ''),
    });
  };

  const onclicklogin = async (e) => {
    e.preventDefault();
    if (validateForm()) {
      setIsloading(true);
      setButtonDisabled(true);

      const otpResponse = await dispatch(generateEmailOtp({
        email: state.email,
        password: state.password
      }));

      if (otpResponse === undefined) {
        setIsloading(false);
        setButtonDisabled(false);
        return;
      }

      const handleError = (response) => {
        const message =
          response?.data?.errors?.[0] ||
          response?.data?.message ||
          "Something went wrong.";

        notify.error(message);
        setIsloading(false);
        setButtonDisabled(false);
      };

      if (otpResponse.status === 429 || otpResponse.status === 400) {
        handleError(otpResponse);
        return;
      }

      if (otpResponse?.data?.success === true) {
        notify.success(otpResponse?.data?.message);
        setIsOtpStep(true);
        const expirySeconds = otpResponse?.data?.meta?.resend_otp_seconds;
        if (expirySeconds !== undefined) {
          setOtpTimer(expirySeconds);
          setCanResendOtp(false);
        }
      } else {
        const backendMessage =
          otpResponse?.data?.errors?.[0] ||
          otpResponse?.data?.message ||
          "Failed to send OTP";
        notify.error(backendMessage);
        setDataState({
          email: "",
          password: "",
        });
      }

      setIsloading(false);
      setButtonDisabled(false);
    }
  };

  // ✅ ADDED
  const verifyOtpHandler = async () => {

    const otpRegex = /^\d{6}$/;

    if (!otp) {
      notify.error("Please enter OTP");
      return;
    }

    if (!otpRegex.test(otp)) {
      notify.error("OTP must be exactly 6 digits");
      return;
    }

    setIsloading(true);

    const verifyResponse = await dispatch(verifyEmailOtp({
      email: state.email,
      otp: otp
    }));

    if (verifyResponse?.data?.success === true) {

      const user = verifyResponse.data.data.user;
      setUserAuthCookies(user);

      notify.success(verifyResponse?.data?.message);

      if (user?.is_first_login === true) {
        dispatch({ type: SET_FIRST_LOGIN });
        setTimeout(() => {
          window.location.replace('/setting/changepassword');
        }, 500);
      } else {
        redirectUser(user);
      }

    } else {

      notify.error("Invalid/Expired OTP");

    }

    setIsloading(false);
  };

  const resendOtpHandler = async () => {

    if (!canResendOtp) return;

    setIsloading(true);

    const response = await dispatch(generateEmailOtp({
      email: state.email,
      password: state.password
    }));

    if (response?.data?.success === true) {

      notify.success(response?.data?.message);

      setOtp("");
      setCanResendOtp(false);
      const expirySeconds = response?.data?.meta?.resend_otp_seconds;
      setOtpTimer(expirySeconds);
    } else {

      notify.error("Failed to resend OTP");

    }

    setIsloading(false);
  };

  const backToLoginHandler = () => {
    setIsOtpStep(false);
    setOtp("");

    setOtpTimer(0);
    setCanResendOtp(false);
    setDataState({
      email: "",
      password: ""
    });
  };


  const validateForm = () => {
    if (!state.email.trim()) {
      setError({ emailError: "Please enter email", passwordError: "" });
      return false;
    }
    if (!EMAIL_REGEX.test(state.email)) {
      setError({ emailError: "Please enter valid email", passwordError: "" });
      return false;
    }
    if (!state.password) {
      setError({ emailError: "", passwordError: "Please enter password" });
      return false;
    }

    setError({ emailError: "", passwordError: "" });
    return true;
  };

  const redirectUser = (user) => {
    const is3w = user?.vehicle_type_master?.toLowerCase() === "3w";
    const isSuperAdmin = user?.role?.toLowerCase() === "super_admin";
    const permissions = user?.permissions || [];

    const threeWRoutes = [
      { permission: "pgm_registration_approval", path: "/3w/pgmlist" },
      { permission: "support_access", path: "/3w/support/query" },
      { permission: "schedule_notifications", path: "/notification" },
    ];

    const defaultRoutes = [
      { permission: "pgm_registration_approval", path: "/pgmlist" },
      { permission: "schedule_notifications", path: "/notification" },
      { permission: "incentive_mapping", path: "/rewardredeem" },
      { permission: "view_reports", path: "/reportgeneration" },
      { permission: "redemption_limit", path: "/redemptionlimit" },
      { permission: "support_access", path: "/query" },
      { permission: "can_access_msr", path: "/msr" },
      { permission: "generate_unique_id", path: "/uniqueidgenerationlist" },
      { permission: "can_access_dsr", path: "/dsr" },
      { permission: "upload_beat_plan", path: "/beatmanagement" },
      { permission: "can_access_dbt_mapping", path: "/dbtrulemanagement" },
      { permission: "upload_pincode_master", path: "/pincodemasterlist" },
      { permission: "target_vs_achievement", path: "/planvsactual" },
    ];

    const routes = is3w ? threeWRoutes : defaultRoutes;
    const superAdminPath = is3w ? "/3w/pgmlist" : "/pgmlist";

    const matchedRoute = routes.find(route => permissions.includes(route.permission));
    const redirectPath = matchedRoute?.path || (isSuperAdmin ? superAdminPath : null);

    if (redirectPath) {
      setTimeout(() => {
        window.open(redirectPath, "_self");
      }, 500);
    }
  };

  const onforgetPasswordclick = () => {
    localStorage.clear();
    sessionStorage.clear();
    Cookies.remove('csrftoken');
    Cookies.remove('_GRECAPTCHA');
    navigate("/forgotpassword")
  }

  const handleOtpChange = (e, index) => {
    const value = e.target.value;

    if (!/^\d?$/.test(value)) return;

    let newOtp = otp.split("");
    newOtp[index] = value;
    newOtp = newOtp.join("");

    setOtp(newOtp);

    // Move to next box automatically
    if (value && index < 5) {
      otpRefs.current[index + 1].focus();
    }
  };

  const handleOtpKeyDown = (e, index) => {
    if (e.key === "Backspace" && !otp[index] && index > 0) {
      otpRefs.current[index - 1].focus();
    }
  };

  return (
    <div className="LoginConatiner">
      <div className="loginMainParent">
        <div className="loginMain">
          {/* <div className="loginLogoWrapper">
            <img src="/img/tvs_logo.svg" alt="TVS Logo" className="loginLogo" />
          </div> */}
          <img src="/img/truchamp-logo.png" alt="Truchamp Logo" className="loginProjectLogo" />
          <div className="loginDivider"></div>
          <div>
            <span className="HeadingLogins">Admin Login</span>
          </div>
          <form onSubmit={onclicklogin}>
            {!isOtpStep ? (
              <>
                <div className="LoginEmails">
                  <input
                    className="LoginEmailInput"
                    type="email"
                    placeholder="Enter Your Email*"
                    name="email"
                    value={state.email}
                    onChange={handleChange}
                  />
                  {Error.emailError && (
                    <span className="ErrorMessage-login montserrat-font">{Error.emailError}</span>
                  )}
                </div>

                <div className="LoginEmails">
                  <input
                    className="LoginEmailInput"
                    type={isPasswordVisible ? "text" : "password"}
                    placeholder="Enter Your Password*"
                    name="password"
                    value={state.password}
                    onChange={handleChange}
                  />
                  <span className={`passIcon ${isPasswordVisible ? "visible" : ""}`} onClick={handlePasswordVisibility}>
                    {isPasswordVisible ? <FaEyeSlash /> : <FaEye />}
                  </span>
                  {Error.passwordError && (
                    <span className="ErrorMessage-login montserrat-font">{Error.passwordError}</span>
                  )}
                </div>

                <div className="LoginButtonParent">
                  <button className="LoginButton" type="submit" disabled={isButtonDisabled}>
                    {isLoading ? <Loader /> : "Login"}
                  </button>
                </div>
              </>
            ) : (
              <>
                {/* ✅ NEW OTP BOXES */}
                <div className="otpContainer">
                  {[...Array(6)].map((_, index) => (
                    <input
                      key={index}
                      type="text"
                      maxLength={1}
                      inputMode="numeric"
                      className="otpBox"
                      value={otp[index] || ""}
                      onChange={(e) => handleOtpChange(e, index)}
                      onKeyDown={(e) => handleOtpKeyDown(e, index)}
                      ref={(el) => (otpRefs.current[index] = el)}
                    />
                  ))}
                </div>

                <div className="LoginButtonParent">
                  <button type="button" className="LoginButton" onClick={verifyOtpHandler}>
                    {isLoading ? <Loader /> : "Verify OTP"}
                  </button>
                </div>

                <div className="LoginButtonParent">
                  {canResendOtp ? (
                    <span className="resendOtp" onClick={resendOtpHandler}>
                      Resend OTP
                    </span>
                  ) : (
                    <span className="resendOtpDisabled">Resend OTP in {otpTimer}s</span>
                  )}
                </div>

                <div className="LoginButtonParent">
                  <span className="back_btn" onClick={backToLoginHandler}>
                    Back to Login
                  </span>
                </div>

              </>
            )}

            {!isOtpStep && (
              <div className="LoginButtonParent">
                <span className="forgetPassword" onClick={onforgetPasswordclick}>
                  Forgot Password
                </span>
              </div>
            )}
          </form>

        </div>
      </div>
    </div>
  )
}
export default Login;